import { render, staticRenderFns } from "./TrainingModules.vue?vue&type=template&id=68d45079&"
import script from "./TrainingModules.vue?vue&type=script&lang=js&"
export * from "./TrainingModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports